<template>
  <div class="form-group">
    <label>{{ props.label }}</label>
    <DxTextBox v-model="inputValue" :maxLength="props.maxLength">
      <DxValidator ref="dxValidatorRef">
        <DxCustomRule :validationCallback="validateInput" :message="$t('shared.input_box.campo_requerido')" />
        <DxEmailRule v-if="props.isEmail" :message="$t('shared.input_box.email_invalido')" />
      </DxValidator>
    </DxTextBox>
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, onMounted, ref } from 'vue';
import { modalDefinedEmits, type ToolbarReference, useModalBuilder } from '@helpers/modal-building-helper';
import { messageBoxResult } from '@components/dialogs/message-box';
import { DxButton } from 'devextreme-vue/button';
import { DxTextBox } from 'devextreme-vue/text-box';
import { DxValidator, DxCustomRule, DxEmailRule } from 'devextreme-vue/validator';

const props = withDefaults(defineProps<{
  label: string,
  required: boolean,
  isEmail?: boolean,
  maxLength?: number
}>(), {
  label: '',
  required: false,
  isEmail: false,
  maxLength: undefined
});

const inputValue = ref<string | null>(null);
const dxValidatorRef = ref<DxValidator>();

defineEmits([...modalDefinedEmits]);

onMounted(() => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!);

  configureButtons(modal);
});

function configureButtons(modal: ReturnType<typeof useModalBuilder>) {
  let okButton: ToolbarReference<DxButton>;
  let cancelButton: ToolbarReference<DxButton>;

  ({ okButton, cancelButton } = modal.standardButtons.addOkCancel());
  okButton.update(w => w.onClick = () => {
    const validationResult = dxValidatorRef.value!.instance!.validate();
    if (validationResult.isValid) {
      modal.close({ result: messageBoxResult.ok, value: inputValue.value });
    } else
      dxValidatorRef.value!.instance!.focus();
  });
  cancelButton.update(w => w.onClick = () => modal.close({ result: messageBoxResult.cancel }));
}

function validateInput(e: { value: string | null }): boolean {
  if (!props.required)
    return true;

  return e.value !== null && e.value.trim() !== "";
}
</script>

<style scoped lang="scss">
.form-group>label {
  margin-bottom: 1rem;
}

.form-group {
  min-height: 110px;
}
</style>